import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./style.scss";

interface StockTabsProps {
    onChange: (key: string) => void;
    activeKey: any;
}

const StocksTabs: React.FC<StockTabsProps> = ({ onChange, activeKey }) => {
    return (
        <div className="tabs-container">
            <Tabs
                onSelect={(val) => onChange(val as string)}
                activeKey={activeKey}
            >
                <Tab tabClassName="tabs-container" eventKey="1" title=" دستی" />
                <Tab
                    tabClassName="tabs-container"
                    eventKey="2"
                    title="بارکد اسکنر"
                />
            </Tabs>
        </div>
    );
};

export default StocksTabs;
